import axios from 'services/axios';

export const getEVETokens = async (room, stream, sub, key) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_EVE_HOST}/api/v1/room/${room}?sub=${sub}&dev=false&shared=true&stream=${stream}`,
      {
        headers: {
          Authorization: key,
          // hardcoded key for the testing purposes
          // Authorization: process.env.REACT_APP_EVE_TOKEN,
        },
      },
    );

    return data.tokens;
  } catch (e) {
    throw new Error(`EVE_ERROR ${e}`);
  }
};
